<template>
  <div>
    <Navbar v-if="navbar" />
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
import "../styles.scss";
import Navbar from "@/components/Navbar.vue";

export default {
  data: () => {
    return {
      navbar: true,
      test: {
        display: "show"
      }
    };
  },
  mounted() {
    this.check_url();
  },
  methods: {
    check_url() {
      if (this.$route.params.device_type == "app") {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    }
  },
  components: {
    Navbar
  },
  watch: {
    $route() {
      if (this.$route.params.device_type == "app") {
        this.check_url();
      }
    }
  }
};
</script>
<style></style>
